import { Routes } from '@angular/router';

// Die Parent-Route für die Maschinen
export const MACHINES_BASE_ROUTE = 'machines';
// Die Child-Routen für die Maschinen
export const MACHINES_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/machie-list/machines.page.component')
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./features/machine-show/machine-details.page.component')
  },
];
